import { render, staticRenderFns } from "./offerArchive.vue?vue&type=template&id=2de49340&scoped=true&"
import script from "./offerArchive.vue?vue&type=script&lang=js&"
export * from "./offerArchive.vue?vue&type=script&lang=js&"
import style0 from "./offerArchive.vue?vue&type=style&index=0&id=2de49340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de49340",
  null
  
)

export default component.exports